import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1df1c810"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: ""
};
const _hoisted_2 = {
  class: "dialog-footer"
};
import { useVModel, useDebounceFn } from '@vueuse/core';
import { ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { getMaterialCategoryTree, addMaterial, editMaterial } from '@/api/material';
import CropImageUpload from '@/components/CropImageUpload';
import EditorCom from '@/components/EditorCom';
export default {
  __name: 'MaterialDialog',
  props: {
    // 回显数据
    model: {
      type: Object,
      default: null
    },
    // dialog显示
    modelValue: {
      type: Boolean,
      required: true
    }
  },
  emits: ['update:modelValue', 'refreshData', 'clearModel'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const treeData = ref([]);
    const _getMaterialCategoryTree = async () => {
      const res = await getMaterialCategoryTree();
      treeData.value = res;
    };

    // 表单数据
    const formData = ref({
      categoryId: '',
      // 素材分类id
      content: '',
      // 素材内容
      cover: '',
      // 素材封面
      title: '',
      // 素材标题
      introduction: ''
    });

    // 清空表单数据
    const resetForm = () => {
      formData.value = {
        categoryId: '',
        // 素材分类id
        content: '',
        // 素材内容
        cover: '',
        // 素材封面
        title: '',
        // 素材标题
        introduction: ''
      };
    };
    watch(() => props.model, val => {
      if (val) {
        formData.value = {
          ...JSON.parse(JSON.stringify(val))
        };
      } else {
        resetForm();
      }
    }, {
      deep: true,
      immediate: true
    });
    // 给父组件派发事件
    const emits = __emit;

    // dialog显示
    const isVisible = useVModel(props);

    // 表单校验
    const rules = ref({
      categoryId: [{
        required: true,
        message: '请选择素材分类',
        trigger: 'blur'
      }],
      title: [{
        required: true,
        message: '素材标题不能为空',
        trigger: 'blur'
      }],
      cover: [{
        required: true,
        message: '封面不能为空',
        trigger: 'blur'
      }],
      content: [{
        required: true,
        message: '素材内容不能为空',
        trigger: 'blur'
      }],
      introduction: [{
        required: true,
        message: '素材简介不能为空',
        trigger: 'blur'
      }]
    });

    // 表单元素
    const formEl = ref(null);
    /**
     * 新增appid
     */
    const addNewsGmHandler = useDebounceFn(async () => {
      if (!formEl.value) return;
      await formEl.value.validate(async (valid, fields) => {
        if (!valid) return;
        try {
          if (!props.model) {
            await addMaterial({
              ...formData.value
            });
          } else {
            await editMaterial({
              ...formData.value
            });
          }
          emits('refreshData');
          ElMessage({
            type: 'success',
            message: props.model ? '修改成功' : '添加成功'
          });
        } catch (error) {
          // console.log(error)
        } finally {
          isVisible.value = false;
        }
      });
    }, 300);
    const closed = () => {
      formEl.value.resetFields();
      resetForm();
      if (props.model) {
        emits('clearModel');
      }
    };
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        modelValue: _unref(isVisible),
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _isRef(isVisible) ? isVisible.value = $event : null),
        title: __props.model ? '修改素材' : '新增素材',
        width: "70%",
        onClosed: closed,
        class: "dialog-class",
        "close-on-click-modal": false,
        onOpen: _getMaterialCategoryTree,
        "destroy-on-close": true
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
          onClick: _cache[5] || (_cache[5] = $event => isVisible.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: _unref(addNewsGmHandler)
        }, {
          default: _withCtx(() => [_createTextVNode(" 确认 ")]),
          _: 1
        }, 8, ["onClick"])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          "label-width": "150px",
          model: formData.value,
          rules: rules.value,
          style: {
            "max-width": "90%"
          },
          ref_key: "formEl",
          ref: formEl
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            prop: "categoryId",
            label: "素材分类"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: formData.value.categoryId,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.value.categoryId = $event),
              placeholder: "请选择素材分类",
              style: {
                "width": "400px"
              }
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(treeData.value, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  value: item.id,
                  label: item.title
                }, null, 8, ["value", "label"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            prop: "title",
            label: "素材标题"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              style: {
                "width": "400px"
              },
              modelValue: formData.value.title,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formData.value.title = $event),
              placeholder: "请输入素材标题"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            prop: "introduction",
            label: "素材简介"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              type: "textarea",
              modelValue: formData.value.introduction,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => formData.value.introduction = $event),
              style: {
                "width": "400px"
              },
              placeholder: "请输入素材简介"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            prop: "cover",
            label: "素材封面"
          }, {
            default: _withCtx(() => [_createVNode(_unref(CropImageUpload), {
              modelValue: formData.value.cover,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => formData.value.cover = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            prop: "content",
            label: "素材内容"
          }, {
            default: _withCtx(() => [_createVNode(_unref(EditorCom), {
              modelValue: formData.value.content,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => formData.value.content = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["modelValue", "title"])]);
    };
  }
};